import styled from "styled-components";

export const Wrapper = styled.div`
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
font-family: 'Inter';
   color: black;
`